<template>
    <div class="content">
        <p v-html="content"></p>
    </div>
</template>

<script>
export default {
    name: 'Details',
    props:{
        content: String
    }
};
</script>

<style lang="scss" scoped>
.content{
    padding-left: 31px;
    font-size: 15px;
}
p{
  text-indent: 1.5em;
  margin-top: 0 ;
}
</style>
